import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';
import { clsx } from 'clsx';

interface Props {
  onClick: () => void;
  className?: string;
  id?: string;
}

export const InstructionButton: React.FC<Props> = observer(({ onClick, className, id }) => (
  <Box id={id} onClick={onClick} className={clsx('w-[180px] h-[90px] cursor-pointer', className)}>
    <img
      alt={'video-instruction'}
      src={'/img/instruction.png'}
      className={'w-full h-full z-[1201] relative rounded-lg'}
    />
  </Box>
));
